import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { extendSalesPeriodMutation } from '../queries/team';
import { Button } from '../common';

interface ExtendSalesPeriodProps {
  match: {
    params: {
      teamId: string;
      extensionToken: string;
    };
  };
}

const ExtendSalesPeriod: React.FC<ExtendSalesPeriodProps> = ({ match }) => {
  const { teamId, extensionToken } = match.params;
  const [status, setStatus] = useState<'confirm' | 'loading' | 'success' | 'error'>('confirm');
  const [errorMessage, setErrorMessage] = useState<string>('');

  const [extendSalesPeriod] = useMutation(extendSalesPeriodMutation, {
    onCompleted: (data) => {
      console.log('Sales period extended successfully:', data);
      setStatus('success');
    },
    onError: (error) => {
      console.error('Error extending sales period:', error);
      setErrorMessage(error.message);
      setStatus('error');
    }
  });

  const handleConfirm = () => {
    setStatus('loading');
    extendSalesPeriod({
      variables: {
        teamId,
        extensionToken
      }
    });
  };

  return (
    status === 'success'
      ? <div className="h-screen container flex flex-col items-center justify-center text-center gap-1">
        <h2 className="mb">Försäljningsperiod förlängd!</h2>
        <p className="mb-lg text-center">Försäljningsperioden har förlängts med 7 dagar. Ni kan nu fortsätta sälja häften.</p>
        <Button className="primary lg" onClick={() => window.close()}>
          Stäng
        </Button>
      </div>
      :
      <div className="h-screen container flex flex-col items-center justify-center text-center gap-1">
        <h2 className="mb">Förläng försäljningsperiod</h2>
        <p className="mb-lg text-center">
          Är du säker på att du vill senarelägga sista försäljningsdagen med 7 dagar?<br />
          Det kan innebära att er utbetalning kommer 1-2 veckor senare än planerat.
        </p>
        {errorMessage && <p className="mb-lg text-center error">{errorMessage}</p>}
        <Button className="primary lg" onClick={handleConfirm} loading={status === 'loading'}>
          Ja, senarelägg sista försäljningsdagen och utbetalningen
        </Button>
        <Button className="secondary lg" onClick={() => window.close()}>
          Avbryt
        </Button>
      </div>
  );
};

export default ExtendSalesPeriod; 
